<template>
  <div class="form">
    <el-form
      ref="form"
      label-width="150px"
      :model="formData"
      :rules="rules"
      label-position="left"
    >
      <el-form-item :label="language('shopCategory.code')" prop="code">
        <div class="input">
          <!-- <template v-if="formData.id">
            {{ formData["code"] }}
          </template>
          <template v-else> -->
          <el-input v-model="formData['code']"></el-input>
          <!-- </template> -->
        </div>
      </el-form-item>
      <el-form-item :label="language('shopCategory.nameChi')" prop="name">
        <div class="input">
          <el-input v-model="formData['name']"></el-input>
        </div>
      </el-form-item>
      <el-form-item :label="language('shopCategory.nameEng')" prop="nameEn">
        <div class="input">
          <el-input v-model="formData['nameEn']"></el-input>
        </div>
      </el-form-item>

      <!-- <el-form-item :label="language('shopCategory.thumb')">
        <div class="input">
          <cc-uploader
            :config="uploaderConf"
            fType="image"
            v-model="formData['thumb']"
            :fFormatV2="['.jpg', '.png']"
          />
        </div>
      </el-form-item> -->

      <el-form-item label="parent">
        <div class="input">
          <!-- <el-input
            v-model="formData['parentId']"
            @input="input_floor_num_2"
          ></el-input>
          <el-alert title="父级分类ID,0为顶级"></el-alert> -->
          <el-select v-model="formData['parentId']" placeholder>
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item :label="language('shopCategory.isShow')" prop="isShow">
        <div class="input">
          <el-select v-model="formData['isShow']" placeholder="">
            <el-option
              v-for="item in status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </el-form-item>

      <el-form-item :label="language('shopCategory.sort')" prop="sort">
        <div class="input">
          <el-input
            v-model="formData['sort']"
            @input="input_floor_num"
          ></el-input>
        </div>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="save">{{
          language("shopCategory.save")
        }}</el-button>
      </el-form-item>
    </el-form>
    <template v-if="formData.id">
      <div>Product (s) in Category</div>
      <el-divider></el-divider>
      <div class="count_tips">
        <div>
          <el-button type="primary" @click="addToCat">{{
            language("shopCategory.addToCat")
          }}</el-button>
          <el-button type="primary" @click="addInBatch">{{
            language("shopCategory.addInBatch")
          }}</el-button>
          <el-button type="primary" @click="topInBatch">{{
            language("shopCategory.topInBatch")
          }}</el-button>
          <el-button type="danger" @click="deleteBatch">{{
            language("shopCategory.deleteInBatch")
          }}</el-button>
        </div>
      </div>

      <cc-table
        :loadData="true"
        :config="table"
        :params="params"
        :refeshParams="refeshTable"
        @selecting-result="contentSelect"
        :showIndex="false"
        :emptyText="language('shopCategory.emptyText')"
      ></cc-table>
    </template>

    <!--手選導入-->
    <el-dialog
      :title="language('shopCategory.content')"
      :visible.sync="adddialog"
      :close-on-click-modal="false"
      width="90%"
      append-to-body
    >
      <template v-if="adddialog">
        <search
          :config="searchConfig"
          @doSearch="doSearch"
          size="medium"
        ></search>
        <cc-table
          v-if="contentParams.isPackage!=1"
          :loadData="true"
          :config="contentTable"
          :params="contentParams"
          :refeshParams="contentRefeshTable"
          @submit-select="submitSelect"
          :emptyText="language('shopCategory.emptyText')"
        ></cc-table>

        <cc-table
          v-if="contentParams.isPackage==1"
          :loadData="true"
          :config="setDetailsTable"
          :params="contentParams"
          :refeshParams="contentRefeshTable"
          @submit-select="submitSelect"
          :emptyText="language('shopCategory.emptyText')"
        ></cc-table>
      </template>
    </el-dialog>

    <!--文件導入-->
    <el-dialog
      :title="language('shopCategory.import')"
      :visible.sync="importdialog"
      :close-on-click-modal="false"
      width="50%"
      append-to-body
    >
      <el-row>
        <el-col>
          <div class="file_box">
            <input type="file" @change="chenge" />
            <el-button>{{ language("shopCategory.file") }}</el-button>
            {{ target }}
          </div>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col>
          <label class="label" style="margin-right: 10px">{{
            language("shopCategory.downloadTemp")
          }}</label>
          <el-button type="primary" size="mini" @click="downloadTemp">{{
            language("shopCategory.download")
          }}</el-button>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="importdialog = false">{{
          language("shopCategory.cancel")
        }}</el-button>
        <el-button type="primary" @click="doSubmitBatch()">{{
          language("shopCategory.confirm")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import uploadUtils from "../../../utils/ossUtils";
import search  from "../../../components/search.vue"

import axios from "axios";

export default {
  props: {
    editData: Object,
  },
  components:{
    search
  },
  data() {
    return {
      uploaderConf: uploadUtils.configPublish,
      table: {
        api: "admin/merchant/category/rel/query",
        showPager: true,
        selection: true,
        selectionNoSubmit: true,
        selectingResult: true,
        selectType: "Object",
        indexFixed: "left",
        columns: [
          {
            minWidth: 110,
            prop: "objData.saleStatus",
            lable: "Displayed",
            type: "tag",
            render: (rows) => {
              if (rows.objData) {
                return rows.objData.saleStatus;
              }
            },
            options: {
              1: {
                tagType: "success",
                text: this.language("productDetails.online"),
              },
              0: {
                tagType: "info",
                text: this.language("productDetails.offline"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.invisible"),
              },
            },
          },
          {
            minWidth: 120,
            prop: "objData.auditStatus",
            lable: "Status",
            type: "tag",
            render: (rows) => {
              if (rows.objData) {
                return rows.objData.auditStatus;
              }
            },
            options: {
              0: {
                tagType: "info",
                text: this.language("productDetails.submit"),
              },
              1: {
                tagType: "success",
                text: this.language("productDetails.approved"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.rejected"),
              },
              // hide: {
              //   tagType: "danger",
              //   text: this.language("productDetails.hide"),
              // },
            },
          },
          {
            prop: "objData.type",
            lable: "type",
            minWidth: 190,
            type: "tag",
            options: {
              H: {
                tagType: "success",
                text: "Non Book",
              },
              C: {
                tagType: "success",
                text: "(Book) Mainland/國版",
              },
              D: {
                tagType: "success",
                text: "(Book) HKG/港版",
              },
              E: {
                tagType: "success",
                text: "(Book) TWN/台版",
              },
              F: {
                tagType: "success",
                text: "(Book) Others/外文版",
              },
              A: {
                tagType: "success",
                text: "(Book)SUP/本版",
              },
              'DT000': {
                tagType: "success",
                text: "PRY.HK/小學教參",
              },
              "DT100": {
                tagType: "success",
                text: "SEC.HK/中學教參",
              },
              "DT200": {
                tagType: "success",
                text: "UNI.HK/大專教參",
              },
              'FT000': {
                tagType: "success",
                text: "PRY.F/外文小學教參",
              },
              "FT100": {
                tagType: "success",
                text: "SEC.F/外文中學教參",
              },
              'FT200': {
                tagType: "success",
                text: "UNI.F/外文大專教參",
              },
            },
          },
          {
            prop: "objData.barcode",
            lable: "SKU ID（Barcode）",
            minWidth: 150,
            render: (rows) => {
              if (rows.objData) {
                return rows.objData.barcode;
              }
            },
          },
          {
            prop: "objData.name",
            lable: "Product Name（Chi.）",
            minWidth: 180,
            render: (rows) => {
              if (rows.objData) {
                return rows.objData.name;
              }
            },
          },
          {
            prop: "objData.categories",
            lable: "Category（System）",
            minWidth: 120,
            render: (rows) => {
              if (rows.objData) {
                return rows.objData.categories;
              }
            },
          },
          {
            prop: "objData.brand",
            lable: "Brand",
            minWidth: 120,
            render: (rows) => {
              if (rows.objData) {
                return rows.objData.brand;
              }
            },
          },
          {
            prop: "objData.listPrice",
            lable: "OriginalPrice",
            render: (rows) => {
              if (rows.objData) {
                return this.$utils.toFixedDigit(rows.listPrice, 2);
              }
            },
            minWidth: 100,
          },
          // {
          //   prop: "updateAdminId",
          //   lable: "Update By",
          //   minWidth: 150,
          // },
          // {
          //   prop: "updateTime",
          //   lable: "Last Update",
          //   minWidth: 150,
          // },
          // {
          //   prop: "createTime",
          //   lable: "Create Date",
          //   minWidth: 150,
          // },
        ],
        buttons: [],
      },
      params: {},
      formData: {},
      refeshTable: -1,
      status: [
        {
          label: this.language("shopCategory.visible"),
          value: 1,
        },
        {
          label: this.language("shopCategory.invisible"),
          value: 0,
        },
      ],
      rules: {
        code: [
          {
            required: true,
            message: this.language("shopCategory.codeTips"),
            trigger: "blur",
          },
          { validator: this.validatePass2, trigger: "blur" },
        ],
        name: [
          {
            required: true,
            message: this.language("shopCategory.nameChiTips"),
            trigger: "blur",
          },
        ],
        isShow: [
          {
            required: true,
            message: this.language("shopCategory.thumbTips"),

            trigger: "blur",
          },
        ],
      },
      adddialog: false,
      searchConfig: [
        {
          title: "SKU ID / Barcode",
          fieldName: "barcode",
          style: "text",
          displayName: "",
        },
        {
          title: "Product Name",
          fieldName: "name",
          style: "text",
          displayName: "",
        },

        {
          title: "Set Details",
          fieldName: "isPackage",
          style: "select",
          displayName: "",
          options: [
            {
              label: "Yes",
              value: "1",
            },
            {
              label: "No",
              value: "0",
            },
          ],
          value:"0",
          clearable:false
        },
      ],
      contentTable: {
        api: "admin/merchant/product/query?status=1",
        showPager: true,
        selection: true,
        selectType: "Object",
        selectingResult: true,
        selectionLabel: this.language("shopCategory.addProduct"),
        indexFixed: "left",
        columns: [
          {
            minWidth: 110,
            prop: "saleStatus",
            lable: "Displayed",
            type: "tag",
            options: {
              1: {
                tagType: "success",
                text: this.language("productDetails.online"),
              },
              0: {
                tagType: "info",
                text: this.language("productDetails.offline"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.invisible"),
              },
              // 1: {
              //   tagType: "danger",
              //   text: "不支持线上销售",
              // },
              // 2: {
              //   tagType: "danger",
              //   text: "待上架",
              // },
            },
          },
          {
            minWidth: 120,
            prop: "auditStatus",
            lable: "Status",
            type: "tag",
            options: {
              0: {
                tagType: "info",
                text: this.language("productDetails.submit"),
              },
              1: {
                tagType: "success",
                text: this.language("productDetails.approved"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.rejected"),
              },
              // hide: {
              //   tagType: "danger",
              //   text: this.language("productDetails.hide"),
              // },
            },
          },
          {
            prop: "type",
            lable: "type",
            type: "tag",
            minWidth: 190,
            options: {
              H: {
                tagType: "success",
                text: "Non Book",
              },
              C: {
                tagType: "success",
                text: "(Book) Mainland/國版",
              },
              D: {
                tagType: "success",
                text: "(Book) HKG/港版",
              },
              E: {
                tagType: "success",
                text: "(Book) TWN/台版",
              },
              F: {
                tagType: "success",
                text: "(Book) Others/外文版",
              },
              A: {
                tagType: "success",
                text: "(Book)SUP/本版",
              },
              'DT000': {
                tagType: "success",
                text: "PRY.HK/小學教參",
              },
              "DT100": {
                tagType: "success",
                text: "SEC.HK/中學教參",
              },
              "DT200": {
                tagType: "success",
                text: "UNI.HK/大專教參",
              },
              'FT000': {
                tagType: "success",
                text: "PRY.F/外文小學教參",
              },
              "FT100": {
                tagType: "success",
                text: "SEC.F/外文中學教參",
              },
              'FT200': {
                tagType: "success",
                text: "UNI.F/外文大專教參",
              },
            },
          },
          {
            prop: "barcode",
            lable: "SKU ID（Barcode）",
            minWidth: 150,
          },
          {
            prop: "name",
            lable: "Product Name（Chi.）",
            minWidth: 180,
          },
          {
            prop: "categories",
            lable: "Category（System）",
            minWidth: 120,
          },
          {
            prop: "brand",
            lable: "Brand",
            minWidth: 120,
          },
          {
            prop: "listPrice",
            lable: "OriginalPrice",
            render: (rows) => {
              return this.$utils.toFixedDigit(rows.listPrice, 2);
            },
            minWidth: 100,
          },
          {
            prop: "updateAdminId",
            lable: "Update By",
            minWidth: 100,
          },
          {
            prop: "updateTime",
            lable: "Last Update",
            minWidth: 200,
          },
          {
            prop: "createTime",
            lable: "Create Date",
            minWidth: 200,
          },
        ],
        buttons: [],
      },
      contentParams: {},
      contentRefeshTable: {},
      importdialog: false,
      importData: {},
      target: "",
      contentData: [],
      options: [],




      setDetailsTable:{
        api: "admin/merchant/product/queryPackage?isPackage=1&auditStatus=1&isQueryProductSale=1",
        showPager:true,
        showPager: true,
        selection: true,
        selectType: "Object",
        selectingResult: true,
        selectionLabel: this.language("shopCategory.addProduct"),
        indexFixed: "left",
        columns: [
          {
            prop: "saleStatus",
            lable: "Displayed",
            type: "tag",
            minWidth: 110,
            options: {
              1: {
                tagType: "success",
                text: this.language("productDetails.online"),
              },
              0: {
                tagType: "info",
                text: this.language("productDetails.offline"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.invisible"),
              },
              // 1: {
              //   tagType: "danger",
              //   text: "不支持线上销售",
              // },
              // 2: {
              //   tagType: "danger",
              //   text: "待上架",
              // },
            },
          },
          {
            prop: "auditStatus",
            lable: "Status",
            type: "tag",
            minWidth: 120,
            options: {
              0: {
                tagType: "info",
                text: this.language("productDetails.submit"),
              },
              1: {
                tagType: "success",
                text: this.language("productDetails.approved"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.rejected"),
              },
              // hide: {
              //   tagType: "danger",
              //   text: this.language("productDetails.hide"),
              // },
            },
          },
          {
            prop: "type",
            lable: "Type",
            type: "tag",
            minWidth: 130,
            options: {
              H: {
                tagType: "success",
                text: "Non Book",
              },
              C: {
                tagType: "success",
                text: "(Book) Mainland/國版",
              },
              D: {
                tagType: "success",
                text: "(Book) HKG/港版",
              },
              E: {
                tagType: "success",
                text: "(Book) TWN/台版",
              },
              F: {
                tagType: "success",
                text: "(Book) Others/外文版",
              },
              A: {
                tagType: "success",
                text: "(Book)SUP/本版",
              },
              'DT000': {
                tagType: "success",
                text: "PRY.HK/小學教參",
              },
              "DT100": {
                tagType: "success",
                text: "SEC.HK/中學教參",
              },
              "DT200": {
                tagType: "success",
                text: "UNI.HK/大專教參",
              },
              'FT000': {
                tagType: "success",
                text: "PRY.F/外文小學教參",
              },
              "FT100": {
                tagType: "success",
                text: "SEC.F/外文中學教參",
              },
              'FT200': {
                tagType: "success",
                text: "UNI.F/外文大專教參",
              },
            },
          },
          {
            prop: "mchProductId",
            lable: "Model ID",
            minWidth: 200,
          },

          {
            prop: "itemSize",
            lable: "Products",
            minWidth: 100,
          },
          {
            prop: "stock",
            lable: "Available Stocks",
            minWidth: 100,
          },
          {
            prop: "name",
            lable: "Product Name（Chi.）",
            minWidth: 180,
          },
          {
            prop: "cover",
            lable: "Product Cover",
            minWidth: 80,
            type: "img",
            urlPropName: "cover",
            sourceUrlPropName: "cover",
            // imgCompressParams: "?x-oss-process=image/resize,w_600",
            w: 40,
            h: 40,
          },
          // {
          //   prop: "categories",
          //   lable: "Category（System）",
          //   minWidth: 120,
          // },
          // {
          //   prop: "brand",
          //   minWidth: 120,
          //   lable: "Brand",
          // },
          {
            prop: "salePrice",
            lable: "Selling Price(HKD)",
            render: (rows) => {
              return this.$utils.toFixedDigit(rows.salePrice * 1, 2);
            },
            minWidth: 100,
          },
          {
            prop: "updateAdminName",
            lable: "Update By",
            minWidth: 100,
          },
          {
            prop: "updateTime",
            lable: "Last Update",
            minWidth: 200,
          },
          {
            prop: "createTime",
            lable: "Create Date",
            minWidth: 200,
          },
        ],
        buttons: [
         
        ],
      }
    };
  },
  methods: {
    validatePass2(rule, value, callback) {
      if (value === "") {
        callback(new Error("Code is required"));
      } else if (!/^[A-Za-z0-9]*$/.test(value)) {
        callback(
          new Error(this.language("shopCampaign.onlyNumberAndCharacterTips"))
        );
      } else {
        callback();
      }
    },
    getData() {
      let e = {};
      e.shopNum = this.$shopData.shopNum;
      e.mchShopNum = this.$shopData.shopNum;
      this.ccRequest
        .do("admin/merchant/category/query?pageSize=100000", e)
        .then((res) => {
          let options = [
            {
              name: "頂級",
              id: "0",
            },
          ];
          for (let i = 0; i < res.rows.length; i++) {
            if (res.rows[i].id != this.editData.id) {
              options.push(res.rows[i]);
            }
          }
          this.options = options;
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(err.response.data.message);
        });
    },
    input_floor_num(value) {
      if (value % 1 != 0 || isNaN(value)) {
        this.$alert(
          this.language("shopCampaign.inputErrorTips"),
          this.language("common.tips"),
          {
            confirmButtonText: this.language("common.confirm"),
            callback: (action) => {
              this.formData.sort = "";
            },
          }
        );
      }
      if (value > 0 || value < 0) {
        this.formData.sort = Math.floor(value);
      }
    },
    input_floor_num_2(value) {
      if (value % 1 != 0 || isNaN(value)) {
        this.$alert(
          this.language("shopCampaign.inputErrorTips"),
          this.language("common.tips"),
          {
            confirmButtonText: this.language("common.confirm"),
            callback: (action) => {
              this.formData.parentId = "";
            },
          }
        );
      }
      if (value > 0 || value < 0) {
        this.formData.parentId = Math.floor(value);
      }
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.formData.cateType = "SHOP";
          this.formData.shopNum = this.$shopData.shopNum;
          this.formData.mchShopNum = this.$shopData.shopNum;
          this.ccRequest
            .do("admin/merchant/category/save", this.formData, "POSTJSON")
            .then((res) => {
              res.parentId = res.parentId+""
              this.formData = res;
              this.params.categoryId = res.id;
              this.$emit("success", true);
              this.$message({
                type: "success",
                message: this.language("shopCategory.success"),
              });
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addToCat() {
      this.adddialog = true;
    },
    doSearch(e) {
   

      if(e.isPackage==1){
          this.contentParams = {
          ...e,
          mchShopNum: this.$shopData.shopNum,
          shopNum: this.$shopData.shopNum,
        };
      }else {
        this.contentParams = {
          ...e,
          mchShopNum: this.$shopData.shopNum,
          shopNum: this.$shopData.shopNum,
        };
      }


    },

    addInBatch() {
      this.importdialog = true;
      this.target = "";
      this.importData = {};
    },
    //手選導入
    submitSelect(e) {
      let data = [];
      for (let i = 0; i < e.length; i++) {
        data.push({
          categoryId: this.formData.id,
          objId: e[i].mb1ProductId,
          objType: "product",
          appId: "supnr",
          shopNum: this.$shopData.shopNum,
          mchShopNum: this.$shopData.mchShopNum,
        });
      }
      this.$confirm(
        this.language("shopCategory.addToCategoryTips"),
        this.language("common.tips"),
        {
          confirmButtonText: this.language("common.confirm"),
          cancelButtonText: this.language("common.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.ccRequest
            .do("admin/merchant/category/rel/batchSave", data, "POSTJSON")
            .then((res) => {
              this.$message({
                type: "success",
                message: this.language("shopCategory.success"),
              });
              this.refeshTable = new Date().getTime();
              this.adddialog = false;
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },

    chenge(e) {
      if (
        e.target.files[0].name.indexOf(".xlsx") > 0 ||
        e.target.files[0].name.indexOf(".xls") > 0
      ) {
        this.target = e.target.value;
        this.importData.file = e.target.files[0];
      } else {
        this.$message.error(this.language("batchAddCard.xlsxErrorTips"));
        return false;
      }
    },
    downloadTemp() {
      window.open("/admin/merchant/file/downloadFile?code=classifyUpload");
      this.$message(this.language("common.downloading"));
    },
    //以文件導入
    doSubmitBatch() {
      if (!this.importData.file) {
        this.$message.error(this.language("shopCategory.fileUploadTips"));
        return false;
      }
      this.$confirm(
        this.language("shopCategory.addBatchTips"),
        this.language("common.tips"),
        {
          confirmButtonText: this.language("common.confirm"),
          cancelButtonText: this.language("common.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let formData = new FormData();
          formData.append("objType", "product");
          formData.append("file", this.importData.file);
          formData.append("appId", "supnr");
          formData.append("shopNum", this.$shopData.shopNum);
          formData.append("mchShopNum", this.$shopData.shopNum);
          axios({
            url: "/admin/merchant/category/rel/import",
            method: "POST",
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
            .then((res) => {
              this.importdialog = false;
              this.refeshTable = new Date().getTime();
              this.$message({
                type: "success",
                message: this.language("shopCategory.success"),
              });
            })
            .catch((err) => {
              var data = err.response.data;
              this.$message.error(data.message);
            });
        })
        .catch(() => {});
    },
    contentSelect(e) {
      this.contentData = e;
    },
    //移除
    deleteBatch(e) {
      if (this.contentData.length == 0) {
        this.$message.error(this.language("shopCategory.chooseProductTips"));
        return false;
      }
      this.$confirm(
        this.language("shopCategory.deleteInBatches"),
        this.language("common.tips"),
        {
          confirmButtonText: this.language("common.confirm"),
          cancelButtonText: this.language("common.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let data = [];
          for (let i = 0; i < this.contentData.length; i++) {
            data.push({
              categoryId: this.formData.id,
              id: this.contentData[i].objId,
              appId: "supnr",
            });
          }
          this.ccRequest
            .do("admin/merchant/category/rel/deleteAndEs", data, "POSTJSON")
            .then((res) => {
              this.$message({
                type: "success",
                message: this.language("shopCategory.success"),
              });
              this.refeshTable = new Date().getTime();
              this.contentData = [];
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },
    //置頂
    topInBatch() {
      if (this.contentData.length == 0) {
        this.$message.error(this.language("shopCategory.chooseProductTips"));
        return false;
      }
      this.$confirm(
        this.language("shopCategory.pinInBatches"),
        this.language("common.tips"),
        {
          confirmButtonText: this.language("common.confirm"),
          cancelButtonText: this.language("common.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let data = [];
          for (let i = 0; i < this.contentData.length; i++) {
            data.push({
              categoryId: this.formData.id,
              objId: this.contentData[i].objId,
              objType: "product",
              appId: "supnr",
            });
          }
          this.ccRequest
            .do(
              "admin/merchant/category/rel/batchUpdateRelSort",
              data,
              "POSTJSON"
            )
            .then((res) => {
              this.$message({
                type: "success",
                message: this.language("shopCategory.success"),
              });
              this.refeshTable = new Date().getTime();
              this.contentData = [];
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.params = {
      shopNum: this.$shopData.shopNum,
      mchShopNum: this.$shopData.shopNum,
      isAsc: true
    };
    this.contentParams = {
      shopNum: this.$shopData.shopNum,
      mchShopNum: this.$shopData.shopNum,
      isPackage:0
    };

    if (this.editData.id) {
      this.params.categoryId = this.editData.id;
      this.formData = { ...this.editData };
    }
    this.getData();
  },
};
</script>
<style scoped>
.input {
  width: 400px;
}
.count_tips {
  margin: 10px 0 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.file_box {
  position: relative;
}
.file_box input {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
</style>
